import { QuestionOptionSaleStartBeforeDate as Question } from "@/components/features/items/edit/option/_shared/ui/components/sale-start-before-date";

import { useOptionSaleStartBeforeDate } from "./hooks";

export const QuestionSaleStartBeforeDate = () => {
	const { isEdited, hasError, saleStartBeforeDate, onSetSaleStartBeforeDate } = useOptionSaleStartBeforeDate();

	return (
		<Question
			isEdited={isEdited}
			hasError={hasError}
			saleStartBeforeDate={saleStartBeforeDate}
			onSetSaleStartBeforeDate={onSetSaleStartBeforeDate}
		/>
	);
};

QuestionSaleStartBeforeDate.displayName = "QuestionSaleStartBeforeDate";
